var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 466.271 532.443",
    style: {
      enableBackground: "new 0 0 466.271 532.443"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M15.421 10.579h437v511h-437z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#b)",
      fill: "#bd88ec"
    },
    d: "M428.515 351.821c-13.735 37.223-34.508 69.59-61.746 96.192-31.004 30.277-71.606 54.336-120.676 71.496a37.236 37.236 0 0 1-4.977 1.359c-2.23.441-4.5.68-6.75.711h-.441c-2.395 0-4.805-.242-7.195-.711a38.122 38.122 0 0 1-4.946-1.348c-49.129-17.132-89.777-41.179-120.816-71.457-27.25-26.601-48.02-58.949-61.735-96.172-24.941-67.679-23.519-142.238-22.378-202.152l.019-.918c.231-4.949.379-10.144.461-15.883.418-28.175 22.82-51.484 50.996-53.058 58.754-3.278 104.203-22.438 143.039-60.293l.34-.309c6.445-5.914 14.57-8.816 22.656-8.695 7.797.101 15.563 2.996 21.782 8.695l.332.309c38.843 37.855 84.293 57.015 143.046 60.293 28.176 1.574 50.579 24.883 50.997 53.058.082 5.778.23 10.965.46 15.883l.012.391c1.137 60.027 2.551 134.73-22.48 202.609zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#b)",
      fill: "#8c53c9"
    },
    d: "M428.515 351.821c-13.735 37.223-34.508 69.59-61.746 96.192-31.004 30.277-71.606 54.336-120.676 71.496a37.236 37.236 0 0 1-4.977 1.359c-2.23.441-4.5.68-6.75.711V10.583c7.797.101 15.563 2.996 21.782 8.695l.332.309c38.843 37.855 84.293 57.015 143.046 60.293 28.176 1.574 50.579 24.883 50.997 53.058.082 5.778.23 10.965.46 15.883l.012.391c1.137 60.027 2.551 134.73-22.48 202.609zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M361.273 266.079c0 70.07-56.895 127.105-126.907 127.355h-.445c-70.219 0-127.359-57.132-127.359-127.355 0-70.219 57.14-127.352 127.359-127.352h.445c70.012.25 126.907 57.286 126.907 127.352zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e1ebf0"
    },
    d: "M361.273 266.079c0 70.07-56.895 127.105-126.907 127.355V138.727c70.012.25 126.907 57.286 126.907 127.352zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "m291.726 247.739-57.36 57.367-12.394 12.391a14.935 14.935 0 0 1-10.602 4.391c-3.84 0-7.676-1.461-10.609-4.391l-26.649-26.656c-5.855-5.856-5.855-15.344 0-21.203 5.852-5.856 15.348-5.856 21.204 0l16.054 16.054 59.153-59.152c5.855-5.859 15.351-5.859 21.203 0 5.855 5.855 5.855 15.351 0 21.199zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c53c9"
    },
    d: "m291.726 247.739-57.36 57.367v-42.414l36.157-36.152c5.855-5.859 15.351-5.859 21.203 0 5.855 5.855 5.855 15.351 0 21.199zm0 0"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkIcon);
export default __webpack_public_path__ + "static/media/checkmarkIcon.083a933bf3f4862796634adf3c959ad6.svg";
export { ForwardRef as ReactComponent };